var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "@/app/UIComponents/BaseDialog";
import { APPEvent } from "@/events/AppEvents";
export class WorkingDialogState {
    constructor() {
        this.baseDialog = new BaseDialogState();
        this.msg = "";
        makeObservable(this);
        this.baseDialog.setHeaderLabel("Working");
        this.baseDialog.setHideFooter(true);
        APPEvent.addSubscriberForAppState(() => {
            this.setOpen(false);
            this.setMessage("");
        });
    }
    setMessage(msg) {
        this.msg = msg;
    }
    setLabel(label) {
        this.baseDialog.setHeaderLabel(label);
    }
    setOpen(open) {
        this.baseDialog.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", BaseDialogState)
], WorkingDialogState.prototype, "baseDialog", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], WorkingDialogState.prototype, "msg", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorkingDialogState.prototype, "setMessage", null);
